import { serviceRoles } from "config/access";
import { COURSE } from "constants/routes";
import { checkAccess } from "helpers/auth";
import CoursePage from "./container/CoursePage";

export default function getSettingsRoute(userAuth) {
  const { account, aptitude } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [aptitude.name]: [aptitude.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: COURSE,
    withSidebar: true,
    withAppBar: true,
    component: CoursePage,
  };
}
